import React from 'react'
import { useIntl } from 'react-intl'
import { Flex, Grid, GridCell } from 'mailup-web-components'
import { storeGet, STORE_KEY_LISTS_COUNT } from 'mailup-react-helpers'
import styled from '@emotion/styled'

const StyledGrid = styled(Grid)`
  border: 1px solid #d5dadf;
  background-color: rgb(238, 238, 238);
  color rgb(37, 37, 37);
  font-size: 14px;
  font-weight: 400;
`

const Head = ({ lastColumnStringId }) => {
  const intl = useIntl()

  const listsCount = storeGet(STORE_KEY_LISTS_COUNT)

  return (
    <StyledGrid variant='collapsed'>
      <GridCell span={1} />
      <GridCell span={4}>
        <Flex padding='10px 16px 10px 16px'>
          {intl
            .formatMessage({ id: 'Load.Schedulation.TableEmailmessage' })
            .toUpperCase()}
        </Flex>
      </GridCell>
      {listsCount > 1 && (
        <GridCell span={1}>
          <Flex padding='10px 16px 10px 16px'>
            {intl
              .formatMessage({ id: 'Load.Schedulation.TableList' })
              .toUpperCase()}
          </Flex>
        </GridCell>
      )}
      <GridCell span={2}>
        <Flex padding='10px 16px 10px 16px'>
          {intl
            .formatMessage({ id: 'Load.Schedulation.TableRecipients' })
            .toUpperCase()}
        </Flex>
      </GridCell>
      <GridCell span={2}>
        <Flex padding='10px 16px 10px 16px'>
          {intl.formatMessage({ id: lastColumnStringId }).toUpperCase()}
        </Flex>
      </GridCell>
      <GridCell span={1} />
      <GridCell span={1} />
    </StyledGrid>
  )
}

export default Head
